"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._outsmartly_serialize_args = _outsmartly_serialize_args;
exports._outsmartly_emit_markers = exports._outsmartly_enabled = exports._outsmartly_dev_mode = void 0;

var _react = _interopRequireDefault(require("react"));

var _htmlSafeJSONStringify = require("./htmlSafeJSONStringify.js");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _outsmartly_dev_mode = !!process.env.OUTSMARTLY_DEV || !!process.env.NEXT_PUBLIC_OUTSMARTLY_DEV; // Regarding NEXT_PUBLIC_OUTSMARTLY_DEV:
// AFAIK there is no way in Next to send process.env variables to
// the *browser* bundle without prefixing it. While understandable,
// not having any way to do it at all means we have to special case.


exports._outsmartly_dev_mode = _outsmartly_dev_mode;

var _outsmartly_enabled = process.env.NODE_ENV === 'production' || _outsmartly_dev_mode;

exports._outsmartly_enabled = _outsmartly_enabled;

var _outsmartly_emit_markers = _outsmartly_enabled && (typeof window !== 'object' || _outsmartly_dev_mode); // TODO(jayphelps): I think this is how we'll do it when we have a
// local dev mode that doesn't require a tunnel.

/* export const _outsmartly_emit_markers =
  (_outsmartly_enabled &&
    typeof window !== 'object' &&
    !_outsmartly_dev_mode) ||
  null; */


exports._outsmartly_emit_markers = _outsmartly_emit_markers;

function _outsmartly_serialize_args(scope, args) {
  if (!_outsmartly_emit_markers) {
    return null;
  }

  return _react.default.createElement('script', {
    type: 'application/json',
    'data-outsmartly-component': scope,
    dangerouslySetInnerHTML: {
      __html: (0, _htmlSafeJSONStringify.htmlSafeJSONStringify)(args)
    }
  });
}